export default "__VITE_ASSET__Bge0WMbf__"